import React, { useState } from "react";
import AppBar from "./AppBar";
import MemberStrip from "./MemberStrip";
import { useMandate } from "./MandateContext";

const PROVIDERS = [
  {
    id: "PHONEPE",
    label: "Navadhan UPI Autopay",
    subtitle: "Powered by NPCI UPI AutoPay",
    color: "#0178B7",
    abbr: "Pe",
    selBg: "#f5f0ff",
    selBorder: "#0178B7",
  },
];

export default function ProviderSelection({ onNext, onBack }) {
  const { state, update } = useMandate();
  const [selected, setSelected] = useState(state.provider || null);

  function handleContinue() {
    if (!selected) return;
    update({ provider: selected });
    onNext();
  }

  const provLabel = selected ? (PROVIDERS.find((p) => p.id === selected) || {}).label || "" : "";

  return (
    <section className="main-sec" style={{ minHeight: "100vh" }}>
      <div className="container fix-width">
        <AppBar title="Choose Provider" onBack={onBack} />
        <MemberStrip memberName={(state.selectedMember && state.selectedMember.memberName) || ""} />

        <div style={{ padding: "20px 0 20px" }}>
          {PROVIDERS.map((p) => {
            const isSel = selected === p.id;
            return (
              <div
                key={p.id}
                onClick={() => setSelected(p.id)}
                style={{
                  background: isSel ? p.selBg : "#fff",
                  border: isSel ? `2px solid ${p.selBorder}` : "1px solid #e5e7eb",
                  borderRadius: 16,
                  padding: "12px 14px",
                  marginBottom: 14,
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                {isSel && (
                  <div style={{
                    position: "absolute", top: 10, right: 10,
                    width: 14, height: 14, borderRadius: "50%", background: p.color,
                  }} />
                )}
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
                  <div style={{
                    width: 44, height: 44, borderRadius: "50%", background: p.color,
                    color: "#fff", display: "flex", alignItems: "center",
                    justifyContent: "center", fontWeight: 700, fontSize: 15, flexShrink: 0,
                  }}>
                    {p.abbr}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{p.label}</div>
                    <div style={{ fontSize: 12, color: "#6b7280" }}>{p.subtitle}</div>
                  </div>
                </div>
              </div>
            );
          })}

          <button
            style={{
              background: selected ? "#0178B7" : "#d1d5db",
              color: "#fff",
              borderRadius: 8,
              border: "none",
              cursor: selected ? "pointer" : "not-allowed",
              width: "100%",
              fontWeight: 700,
              marginBottom: 12,
              padding: "12px 0",
              fontSize: 15,
            }}
            disabled={!selected}
            onClick={handleContinue}
          >
            {selected ? `Continue with ${provLabel}` : "Select a provider to continue"}
          </button>
        </div>
      </div>
    </section>
  );
}
